import { CalendarDays, MapPin } from "lucide-react";
import { dayParts } from "@/lib/dates";
import { Reveal } from "@/components/site/Reveal";

export const SessionList = ({ sessions }) => (
  <div data-testid="session-list">
    <p className="eyebrow mt-14 flex items-center gap-2 text-ochre"><CalendarDays className="h-4 w-4" /> Upcoming sessions</p>
    {!sessions.length && (
      <p data-testid="sessions-empty" className="mt-6 rounded-2xl border border-dashed border-ink/25 p-6 text-sm text-ink/75">
        New dates coming soon. Enrol now and we'll let you know when sessions are scheduled.
      </p>
    )}
    <div className="mt-6 grid gap-3 sm:grid-cols-2">
      {sessions.map((s, i) => {
        const p = dayParts(s);
        return (
          <Reveal key={s.id} delay={i * 0.05}>
            <div data-testid={`session-${s.id}`} className="flex items-center gap-5 rounded-2xl bg-white/60 p-4 transition-transform duration-300 hover:-translate-y-1">
              <div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-xl bg-ink text-sand">
                <span className="font-mono text-[10px] uppercase tracking-widest text-amber">{p.wd}</span>
                <span className="font-display text-2xl leading-none">{p.dd}</span>
                <span className="font-mono text-[10px] uppercase">{p.mm}</span>
              </div>
              <div>
                <p className="font-semibold">{s.start_time}{s.end_time ? ` – ${s.end_time}` : ""}</p>
                {s.location && <p className="mt-1 flex items-center gap-1 text-sm text-ink/75"><MapPin className="h-3.5 w-3.5 text-ochre" />{s.location}</p>}
              </div>
            </div>
          </Reveal>
        );
      })}
    </div>
  </div>
);
